module.exports = __webpack_public_path__ + "assets/img/poster-1.21afead3.png";